import React from "react";
import LoginResource from "../../resources/LoginResource";
import { useResource } from "rest-hooks";
import { Redirect, RouteComponentProps } from "@reach/router";
import { basepath } from "../../constants";

interface IAuthenticated extends RouteComponentProps {
	children: any;
}

const Authenticated = ({ children }: IAuthenticated) => {
	const { isAuthenticated } = useResource(LoginResource.detailShape(), {});

	const fallBackUrl = `${basepath}/login`;

	if (!isAuthenticated) return <Redirect noThrow to={fallBackUrl} />;

	return children;
};

export default Authenticated;
